import React from 'react';
import styled from 'styled-components';

import DetailedCarInfoMessage from '@/components/DetailedCarInfoMessage';

function InfoMessage() {
  return (
    <Component>
      <DetailedCarInfoMessage
        text={
          'Информация, иллюстрации внешнего вида и оснащение автомобиля могут отличаться от приведенных на сайте.'
        }
      />
    </Component>
  );
}

export default InfoMessage;

const Component = styled.div`
  margin: 35px 0 0 0;
`;
